import { apiService } from "../apiService";
import { chartHelper } from "./chartHelper";
import { Datepicker } from 'flowbite';


globalThis.leadsHelper = {
  lineChartLeads: null,
  datePickerFromLeads: null,
  datePickerToLeads: null,
  campaignId: null,
  dateFrom: null,
  dateTo: null,
  interval: "monthly",
  datePickerFormat: "dd.mm.yyyy",

  config: {
    interval: "monthly",
    elementLineChartLeads: "linechartLeads",
    elementDatePickerFrom: "oneDateFieldLeads",
    elementDatePickerTo: "twoDateFieldLeads",
    elementFormLeads: "formLeads",
    gridColor: "#eaeaf5",
    legendColor: "rgb(148, 149, 184)",
    tickColor: "#9495b8",
    dataColor: "#ec4899"
  },

  init: function(campaignId, dateFrom, dateTo, config = {})
  {


    for (const [key, value] of Object.entries(config))
    {
      this.config[key] = value;
    }
    config = this.config;

    this.campaignId = campaignId;
    this.initLineChartLeads("linechartLeads");
    this.initDatePickersLeads(config.elementDatePickerFrom, config.elementDatePickerTo, config.elementFormLeads, dateFrom, dateTo);
  },

  initLineChartLeads: function(elementId)
  {
    if (this.lineChartLeads)
    {
      return this.lineChartLeads;
    }
    this.lineChartLeads = chartHelper.getChart(elementId, this.config.gridColor, this.config.tickColor, this.config.dataColor, this.config.legendColor);
    return this.lineChartLeads;
  },

  updateLeadChart: async function()
  {

    if (this.lineChartLeads === null)
    {
      throw new Error("Linechart Leads not initialized");
    }

    const leadData = await apiService.getLeadData(this.campaignId, this.dateFrom, this.dateTo, this.interval);
    const stats = leadData.stats;
    this.lineChartLeads.data.labels = stats.map(row => row.date);
    this.lineChartLeads.data.datasets.forEach((dataset) =>
    {
      dataset.data = stats.map(row => row.numLeads);
    });
    this.lineChartLeads.update();
  },

  initDatePickersLeads: function(elementFrom, elementTo, formId, initialDateFrom, initialDateTo)
  {
    this.dateFrom = initialDateFrom;
    this.dateTo = initialDateTo;

    const datepickerFromElement = document.getElementById(elementFrom);
    const datepickerToElement = document.getElementById(elementTo);

    let options = { format: this.config.datePickerFormat };

    this.datepickerFromLeads = new Datepicker(datepickerFromElement, options, {
      id: elementFrom,
      override: true
    });
    this.datepickerFromLeads.setDate(initialDateFrom);

    this.datepickerToLeads = new Datepicker(datepickerToElement, options, {
      id: elementTo,
      override: true
    });
    this.datepickerToLeads.setDate(initialDateTo);

    const form = document.getElementById(formId);
    const that = this;

    form.addEventListener("submit", async function(event)
    {
      event.preventDefault();
      that.dateFrom = String(Math.round(that.datepickerFromLeads.getDate().getTime() / 1000));
      that.dateTo = String(Math.round(that.datepickerToLeads.getDate().getTime() / 1000));
      await that.updateLeadChart();
    });
  }
};